import React from "react";
import rehypeReact from 'rehype-react';
import cls from "classnames";
import * as styles from 'src/styles/pages/blog-id.module.scss';
import {Layout} from "src/components/organisms/Layout";
import {BlogContent} from "src/components/organisms/BlogPage/BlogContent";
import {BlogRelease, BlogSubscribe} from "src/components/organisms/Blog";
import {subscribeData} from "src/components/organisms/Blog/mock_blog_data";
import {
    PostFormBannerCloudCosts,
    PostFormBannerSubscribe,
    PostProductBannerAcnp,
    PostProductBannerAlpaquta,
    PostProductBannerLiberica,
    PostProductBannerNik,
    PostFormOptimizingCosts,
    PostFormComparisonTable,
    PostProductBannerLibericaJDK,
    PostProductBannerComparison,
    PostFormBannerMigration,
    PostFormBannerComparative,
    PostFormBannerTwoPhaseMigration,
    PostFormBannerSecuringInfrastructure,
    PostProductBannerBeforeRenewing,
    PostProductThinBannerAlpaquita,
    PostProductBannerCalculateYourSavings,
    PostProductBannerPostponeMigrationJDK17, PostProductBannerQuestionsToAskOpenJDKVendor,
} from "src/components/organisms/Banners/v4/banners";
import {Footer} from "src/components/organisms/BlogPage/BlogContent/blocks/Footer";
import {graphql, withAssetPrefix} from "gatsby";
import {NodeBlogCard} from "components/organisms/Blog/utils/grid";
import {BlogYtIframe} from "components/organisms/BlogYtIframe";
import {BlogImgSharp} from "components/organisms/BlogImgSharp";

const Div = ({ className, children, ...rest }: any) => {
    if (className?.split(' ').includes('mce-toc')) {
        return (
            <nav className={className} aria-label="Table of Contents" {...rest}>
                {children}
            </nav>
        );
    }
    return <div className={className} {...rest}>{children}</div>;
};

// @ts-ignore
const renderAst = new rehypeReact({
    Fragment: React.Fragment,
    createElement: React.createElement,
    components: {
        'div': Div,
        'iframe': BlogYtIframe,
        'img-sharp-inline': BlogImgSharp,
        'product-banner-liberica': PostProductBannerLiberica,
        'product-banner-nik': PostProductBannerNik,
        'product-banner-acnp': PostProductBannerAcnp,
        'product-banner-alpaquita': PostProductBannerAlpaquta,
        'form-banner-subscribe': PostFormBannerSubscribe,
        'form-banner-cloud-cost-wp': PostFormBannerCloudCosts,
        'form-banner-cloud-optimisation-wp': PostFormOptimizingCosts,
        'form-banner-comparison-table': PostFormComparisonTable,
        'product-banner-jdk': PostProductBannerLibericaJDK,
        'product-thin-banner-alpaquita': PostProductThinBannerAlpaquita,
        'product-banner-comparison': PostProductBannerComparison,
        'form-banner-migration': PostFormBannerMigration,
        'form-banner-comparative': PostFormBannerComparative,
        'form-banner-two-phase': PostFormBannerTwoPhaseMigration,
        'form-banner-securing-infrastructure': PostFormBannerSecuringInfrastructure,
        'form-banner-before-renewing-oracle-license': PostProductBannerBeforeRenewing,
        'product-banner-calculate-your-savings': PostProductBannerCalculateYourSavings,
        'product-banner-postpone-migration-jdk': PostProductBannerPostponeMigrationJDK17,
        'product-banner-questions-to-ask-jdk-vendor': PostProductBannerQuestionsToAskOpenJDKVendor,

    },
}).Compiler

export type PostContext = {
    nodeId: string,
    authorsIds?: string[],
    furtherReading: string[],
    furtherReadingCount: number,
    latestPostsCount: number,
}
type postProps = {
    pageContext: PostContext,
    data: {
        postsJson: Queries.PostsJson,
        allAuthorsJson: {nodes: Queries.AuthorsJson[]}
        allFormsJson: {nodes: Queries.FormsJson[]}
        furtherReading: Queries.PostsJsonConnection
        latestPosts: Queries.PostsJsonConnection
        postJsonId: string
    }
}

function Post({pageContext, data: {postsJson, allAuthorsJson, allFormsJson, furtherReading, latestPosts}}: postProps) {
    const posts = [...furtherReading.nodes, ...latestPosts.nodes]
    const post = postsJson
    return (
        <>
            <div className={cls("bg-dark", styles.darkheader)}/>

            <Layout
                forms={allFormsJson.nodes}
                className={styles.page}
                button={{
                    className: cls('bg-cyan color-dark'),
                }}
            >
                <div className={cls("bs-flex-container l", styles.customFlexContainer)}>
                    <div className={cls(styles.content, styles.container)}>
                        <div className={styles.post}>
                            <BlogRelease
                                id={"post-cover-block"}
                                blogData={{
                                    id: pageContext.nodeId,
                                    postData: postsJson,
                                    authorsData: allAuthorsJson.nodes,
                                    postCover: post?.coverImage?.childImageSharp?.gatsbyImageData
                                }}
                                headingLevel={1}
                                enableLink={false}
                                headingClassname={"h2"}
                            />
                            <BlogContent
                                content={post?.childHtmlRehype?.htmlAst ? renderAst(post?.childHtmlRehype?.htmlAst) : <></>}></BlogContent>
                        </div>
                        <div className={styles.sidebar} id={"blog-sidebar"}>

                            {posts.slice(3, 6).map((post, index) =>
                                <NodeBlogCard
                                    id={"blog-sidebar-item-1"}
                                    node={post}/>)
                            }

                            <BlogSubscribe card={subscribeData}/>
                        </div>
                    </div>
                </div>
                <div className={cls("bs-flex-container l")}>
                    <div className={cls(styles.postsContainer)}>
                        <h3 className={styles.postsTitle} id={"further-reading"}>Further reading</h3>
                        <div className={styles.posts} id={"further-reading-wrapper"}>

                            {posts.slice(0, 3).map((post, index) =>
                                <NodeBlogCard
                                    id={"further-reading-item-" + (index + 1)}
                                    node={post}/>)
                            }
                        </div>
                    </div>
                </div>
                <div className={cls("bs-flex-container l", styles.customFlexContainer)}>
                    {allAuthorsJson && allAuthorsJson.nodes.length > 0 &&
                        <div className={styles.authorData}>
                            <Footer authors={allAuthorsJson.nodes}/>
                        </div>}
                </div>
            </Layout>
        </>
    )
}

export const Head = ({
                         data: {
                             postsJson,
                             allAuthorsJson,
                         }
                     }: {
    pageContext: PostContext, data: { postsJson: any, allAuthorsJson: any }
}) => {

    const post = postsJson
    const authors = allAuthorsJson

    const normalizeRelativeUrl = (path?: string | null): string => {
    if (!path) return "";
      return path.replace(/^\/+/, "").replace(/\/+$/, "");
    };

    const schemaOrgJSONLD = {
      "@context": "https://schema.org",
      "@type": "BlogPosting",
      "headline": post?.data?.seo?.iv?.title,
      "description": post?.data?.seo?.iv?.description,
      "image": post.ogCoverImage?.childImageSharp?.resize?.src
          ? withAssetPrefix(post.ogCoverImage.childImageSharp.resize.src)
          : undefined,
      "datePublished": post?.data?.publishedAt?.iv,
      "dateModified": post?.data?.updatedAt?.iv,
      "author": authors?.nodes
          ?.filter((author: any) => author.data?.name?.iv)
          ?.map((author: any) => ({
              "@type": "Person",
              "name": author.data.name.iv,
          })),
      "publisher": {
          "@type": "Organization",
          "name": "BellSoft",
          "logo": {
              "@type": "ImageObject",
              "url": "https://bell-sw.com/assets/images/media-kit/logo-bellsoft-black.png"
          }
      },
      "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": `https://bell-sw.com/blog/${post?.data?.slug?.iv}/`
      },
      "keywords": post?.data?.seo?.iv?.keywords ?? [],
      "articleSection": post?.data?.category?.iv,
      "inLanguage": "en-US"
    }

    return <>
        <title>{post?.data?.seo?.iv?.title}</title>
        {post?.data?.seo?.iv?.description && <meta name="description" content={post?.data?.seo?.iv?.description}/>}
        <meta name="keywords" content={post?.data?.seo?.iv?.keywords ? post?.data?.seo?.iv?.keywords.join(", ") : ""}/>
        {post?.data?.seo?.iv?.title && <meta property="og:title" content={post?.data?.seo?.iv?.title}/>}
        {post?.data?.seo?.iv?.description &&
            <meta property="og:description" content={post?.data?.seo?.iv?.description}/>}
        <meta property="og:type" content="article"/>
        <meta property="og:url" content={`https://bell-sw.com/${normalizeRelativeUrl(post?.data?.relativeUrl?.iv)}/`} />
        {post.ogCoverImage?.childImageSharp?.resize?.src && <meta property="og:image"
                                                content={withAssetPrefix(post.ogCoverImage?.childImageSharp?.resize?.src)}/>}
        <meta property="og:image:type" content="image/png" />
        <meta property="og:image:alt" content={post?.data?.seo?.iv?.title} />
        <meta property="og:site_name" content="BellSoft" />
        <meta property="og:locale" content="en_US" />

        <meta property="article:published_time" content={post?.data?.publishedAt?.iv}/>
        <meta property="article:modified_time" content={post?.data?.updatedAt?.iv}/>
        {authors?.nodes?.map((author: any) => (
          author.data?.name?.iv && (
            <meta
              property="article:author"
              content={author.data.name.iv}
            />
          )
        ))}
        <meta property="article:section" content="Security" />
        <meta property="article:tag" content="Code" />
        <meta property="article:tag" content="JDK" />
        <meta property="article:tag" content="Security" />  
        <meta property="article:tag" content="Containers" />
        <meta property="article:tag" content="SBOM" />
        <meta property="article:tag" content="OpenJDK" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@bellsoftware" />
        <meta name="twitter:title" content={post?.data?.seo?.iv?.title} />
        <meta name="twitter:description" content={post?.data?.seo?.iv?.description} />
        <meta name="twitter:image" content={withAssetPrefix(post.ogCoverImage?.childImageSharp?.resize?.src)} />
        <meta name="twitter:image:alt" content={post?.data?.seo?.iv?.title} />

        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
                __html: JSON.stringify(schemaOrgJSONLD)
            }}
        />
      </>
}

export const pageQuery = graphql`
query ($nodeId: String!, 
    $authorsIds: [String!]!, 
    $formIds: [String!]!, 
    $postJsonId: String!, 
    $furtherReading: [String!]!, 
    $furtherReadingCount: Int!, 
    $latestPostsCount: Int!) {
  site {
    assetPrefix
  }
  postsJson(id: { eq: $nodeId }) {
    childHtmlRehype {
      htmlAst
    }
    fields {
      forms
      timeToReadWithoutCode
      timeToReadWithShrunkCode
      timeToReadWithCode
    }
    data {
      title {
        iv
      }
      category {
        iv
      }
      updatedAt {
        iv
      }
      publishedAt {
        iv
      }
      slug {
        iv
      }
      relativeUrl {
        iv
      }
      seo {
        iv {
          title
          description
          keywords
        }
      }
      furtherReading {
        iv
      }
    }
    created
    status
    coverImage {
      childImageSharp {
        gatsbyImageData(
          pngOptions: { quality: 90 }
          webpOptions: { quality: 90 }
        )
        resize(
          width: 1200
          pngCompressionLevel: 9
          pngQuality: 90
          cropFocus: SOUTHWEST
        ) {
          src
          width
          height
          aspectRatio
          originalName
        }
      }
    }
    ogCoverImage {
      childImageSharp {
        gatsbyImageData(
          pngOptions: { quality: 90 }
          webpOptions: { quality: 90 }
        )
        resize(
          width: 1200
          pngCompressionLevel: 9
          pngQuality: 90
          cropFocus: SOUTHWEST
        ) {
          src
          width
          height
          aspectRatio
          originalName
        }
      }
    }
  }
  allAuthorsJson(filter: { jsonId: { in: $authorsIds } }) {
    nodes {
      data {
        description {
          iv
        }
        email {
          iv
        }
        linkedin {
          iv
        }
        name {
          iv
        }
        thirdPartyAuthor {
          iv
        }
      }
      authorImage {
        childImageSharp {
          gatsbyImageData(
            webpOptions: { quality: 90 }
            pngOptions: { quality: 90 }
            width: 300
            height: 300
            transformOptions: { cropFocus: NORTH }
          )
        }
      }
    }
  }
  
  
  
  furtherReading: allPostsJson(
    limit: $furtherReadingCount
    filter: {jsonId: {in: $furtherReading}}
  ) {
    nodes {
        id
        jsonId
        status
        data {
          title {
            iv
          }
          relativeUrl {
            iv
          }
          seo {
            iv {
              title
              description
            }
          }
          authors {
            iv {
              id
              data {
                name {
                  iv
                }
                description {
                  iv
                }
              }
            }
          }
          category {
            iv
          }
          tags {
            iv
          }
          publishedAt {
            iv
          }
          updatedAt {
            iv
          }
          furtherReading {
            iv
          }
        }
        coverImage {
          childImageSharp {
            gatsbyImageData(pngOptions: {quality: 90}, webpOptions: {quality: 90})
            resize(
              width: 1200
              pngCompressionLevel: 9
              pngQuality: 90
              cropFocus: SOUTHWEST
            ) {
              src
              width
              height
              aspectRatio
              originalName
            }
          }
        }
    }
  }
  latestPosts: allPostsJson(
  limit: $latestPostsCount,
  filter: {jsonId: {ne: $postJsonId}},
  sort: {fields: data___publishedAt___iv, 
                        order: DESC}
  ) {
    nodes {
        id
        jsonId
        status
        data {
          title {
            iv
          }
          relativeUrl {
            iv
          }
          seo {
            iv {
              title
              description
            }
          }
          authors {
            iv {
              id
              data {
                name {
                  iv
                }
                description {
                  iv
                }
              }
            }
          }
          category {
            iv
          }
          tags {
            iv
          }
          publishedAt {
            iv
          }
          updatedAt {
            iv
          }
          furtherReading {
            iv
          }
        }
        coverImage {
          childImageSharp {
            gatsbyImageData(pngOptions: {quality: 90}, webpOptions: {quality: 90})
            resize(
              width: 1200
              pngCompressionLevel: 9
              pngQuality: 90
              cropFocus: SOUTHWEST
            ) {
              src
              width
              height
              aspectRatio
              originalName
            }
          }
        }
    }
  }
  allFormsJson(filter: {fields: {hashedIdSelector: {in: $formIds}}}) {
    nodes {
      fields {
        hashedIdSelector
        idSelector
      }
      title
      successTitle
      successDetails
      successDescription
      items {
        type
        required
        placeholder
        name
        hidden
        gridColumn
      }
      formId
      id
      details
      controls {
        terms {
          name
        }
        button {
          caption
        }
      }
      eventAction
    }
  }
}
`;

export default Post
